import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const EmptyStateSMS = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon
    height={height}
    width={width}
    viewBox="0 0 128 128"
    data-test="sms-empty-state"
    {...props}
  >
    <path
      d="M12 63.2C12 76.7791 17.3943 89.802 26.9961 99.4039C36.598 109.006 49.6209 114.4 63.2 114.4C76.7791 114.4 89.802 109.006 99.4039 99.4039C109.006 89.802 114.4 76.7791 114.4 63.2C114.4 49.6209 109.006 36.598 99.4039 26.9961C89.802 17.3943 76.7791 12 63.2 12C49.6209 12 36.598 17.3943 26.9961 26.9961C17.3943 36.598 12 49.6209 12 63.2V63.2Z"
      fill={colors.grey5}
    />
    <path
      d="M40 103.979C40 104.624 42.4396 105.243 46.782 105.7C51.1244 106.157 57.014 106.413 63.1551 106.413C69.2962 106.413 75.1858 106.157 79.5283 105.7C83.8707 105.243 86.3102 104.624 86.3102 103.979C86.3102 103.333 83.8707 102.714 79.5283 102.257C75.1858 101.8 69.2962 101.544 63.1551 101.544C57.014 101.544 51.1244 101.8 46.782 102.257C42.4396 102.714 40 103.333 40 103.979Z"
      fill={colors.grey15}
    />
    <path
      d="M85.6268 96.011C85.6268 97.6706 84.9675 99.2623 83.7939 100.436C82.6204 101.609 81.0287 102.269 79.369 102.269H46.9384C45.2788 102.269 43.6871 101.609 42.5135 100.436C41.34 99.2623 40.6807 97.6706 40.6807 96.011V26.4575C40.6807 24.7978 41.34 23.2061 42.5135 22.0326C43.6871 20.859 45.2788 20.1997 46.9384 20.1997H79.3721C81.0318 20.1997 82.6235 20.859 83.797 22.0326C84.9706 23.2061 85.6299 24.7978 85.6299 26.4575L85.6268 96.011Z"
      fill="white"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M61.2012 26.0626L71.9481 26.0615"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M55.3411 25.0845C55.0935 25.1005 54.8614 25.2102 54.6918 25.3912C54.5221 25.5722 54.4277 25.811 54.4277 26.059C54.4277 26.3071 54.5221 26.5459 54.6918 26.7269C54.8614 26.9079 55.0935 27.0175 55.3411 27.0336C55.5886 27.0175 55.8208 26.9079 55.9904 26.7269C56.16 26.5459 56.2544 26.3071 56.2544 26.059C56.2544 25.811 56.16 25.5722 55.9904 25.3912C55.8208 25.2102 55.5886 25.1005 55.3411 25.0845Z"
      fill={colors.purple100}
    />
    <path
      d="M59.7363 95.9187C59.7363 96.8255 60.0966 97.6952 60.7378 98.3365C61.379 98.9777 62.2487 99.3379 63.1555 99.3379C64.0624 99.3379 64.932 98.9777 65.5733 98.3365C66.2145 97.6952 66.5747 96.8255 66.5747 95.9187C66.5747 95.0119 66.2145 94.1422 65.5733 93.501C64.932 92.8598 64.0624 92.4995 63.1555 92.4995C62.2487 92.4995 61.379 92.8598 60.7378 93.501C60.0966 94.1422 59.7363 95.0119 59.7363 95.9187V95.9187Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.5918 31.9243H81.7178V89.5676H44.5918V31.9243Z"
      fill={colors.cyan10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.5918 31.9243H62.5996V89.5676H44.5918V31.9243Z"
      fill="white"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M74.3166 47.0576H52.1788C51.1306 47.0576 50.1254 47.474 49.3842 48.2152C48.643 48.9564 48.2266 49.9617 48.2266 51.0099V65.2425C48.2266 65.7615 48.3288 66.2755 48.5274 66.755C48.726 67.2345 49.0172 67.6702 49.3842 68.0372C49.7512 68.4042 50.1869 68.6953 50.6664 68.8939C51.1459 69.0926 51.6598 69.1948 52.1788 69.1948H53.9433L52.9827 74.4781C52.955 74.6308 52.9729 74.7883 53.0341 74.9309C53.0953 75.0735 53.1971 75.195 53.3268 75.2802C53.4565 75.3654 53.6084 75.4106 53.7636 75.4101C53.9188 75.4096 54.0704 75.3635 54.1996 75.2775L63.3236 69.1948H74.3166C75.3649 69.1948 76.3701 68.7784 77.1113 68.0372C77.8525 67.296 78.2689 66.2907 78.2689 65.2425V51.0099C78.2689 49.9617 77.8525 48.9564 77.1113 48.2152C76.3701 47.474 75.3649 47.0576 74.3166 47.0576Z"
      fill="white"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62.6006 64.3516H73.2924"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62.6006 58.1265H73.2924"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62.6006 51.9014H73.2924"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.3842 48.2152C50.1254 47.474 51.1306 47.0576 52.1788 47.0576H63.2477L63.3236 69.1948L54.1996 75.2775C54.0704 75.3635 53.9188 75.4096 53.7636 75.4101C53.6084 75.4106 53.4565 75.3654 53.3268 75.2802C53.1971 75.195 53.0953 75.0735 53.0341 74.9309C52.9729 74.7883 52.955 74.6308 52.9827 74.4781L53.9433 69.1948H52.1788C51.6598 69.1948 51.1459 69.0926 50.6664 68.8939C50.1869 68.6953 49.7512 68.4042 49.3842 68.0372C49.0172 67.6702 48.726 67.2345 48.5274 66.755C48.3288 66.2755 48.2266 65.7615 48.2266 65.2425V51.0099C48.2266 49.9617 48.643 48.9564 49.3842 48.2152Z"
      fill={colors.grey5}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.1381 99.2316C62.3573 99.2355 61.5973 98.9797 60.9779 98.5043C60.3585 98.0289 59.9148 97.361 59.7167 96.6057C59.5186 95.8504 59.5773 95.0507 59.8836 94.3325C60.19 93.6143 60.7265 93.0183 61.4087 92.6385V20.4663C60.7296 20.084 60.1963 19.4875 59.8922 18.7699C59.5882 18.0524 59.5304 17.2543 59.728 16.5005C59.9256 15.7467 60.3675 15.0795 60.9844 14.6035C61.6014 14.1274 62.3588 13.8691 63.1381 13.8691C63.9174 13.8691 64.6747 14.1274 65.2917 14.6035C65.9087 15.0795 66.3505 15.7467 66.5481 16.5005C66.7457 17.2543 66.688 18.0524 66.3839 18.7699C66.0798 19.4875 65.5466 20.084 64.8675 20.4663V92.6385C65.5497 93.0183 66.0862 93.6143 66.3925 94.3325C66.6988 95.0507 66.7575 95.8504 66.5594 96.6057C66.3613 97.361 65.9176 98.0289 65.2982 98.5043C64.6788 98.9797 63.9189 99.2355 63.1381 99.2316Z"
      fill="white"
    />
    <path
      d="M63.1382 14.5259C63.8082 14.5195 64.4593 14.7479 64.9784 15.1715C65.4976 15.5952 65.8519 16.1872 65.98 16.8449C66.1081 17.5026 66.0018 18.1844 65.6795 18.7719C65.3572 19.3593 64.8394 19.8154 64.2159 20.0608V93.0423C64.8341 93.2924 65.3461 93.7497 65.6641 94.3359C65.9821 94.9221 66.0863 95.6006 65.9589 96.2552C65.8315 96.9098 65.4804 97.4996 64.9658 97.9238C64.4511 98.3479 63.805 98.5798 63.1382 98.5798C62.4713 98.5798 61.8252 98.3479 61.3106 97.9238C60.7959 97.4996 60.4448 96.9098 60.3174 96.2552C60.19 95.6006 60.2943 94.9221 60.6122 94.3359C60.9302 93.7497 61.4422 93.2924 62.0604 93.0423V20.0608C61.4369 19.8154 60.9191 19.3593 60.5968 18.7719C60.2746 18.1844 60.1682 17.5026 60.2963 16.8449C60.4244 16.1872 60.7788 15.5952 61.2979 15.1715C61.817 14.7479 62.4681 14.5195 63.1382 14.5259ZM63.1382 13.2227C62.2466 13.2187 61.3772 13.5006 60.6576 14.0269C59.938 14.5533 59.406 15.2964 59.1396 16.1473C58.8733 16.9982 58.8867 17.912 59.1778 18.7547C59.4689 19.5974 60.0224 20.3247 60.7571 20.8297V92.2747C60.026 92.7819 59.476 93.5094 59.1873 94.3511C58.8985 95.1928 58.8861 96.1047 59.1519 96.9539C59.4177 97.8031 59.9477 98.5453 60.6647 99.0722C61.3817 99.5992 62.2483 99.8834 63.1382 99.8834C64.028 99.8834 64.8946 99.5992 65.6116 99.0722C66.3287 98.5453 66.8587 97.8031 67.1244 96.9539C67.3902 96.1047 67.3778 95.1928 67.089 94.3511C66.8003 93.5094 66.2503 92.7819 65.5192 92.2747V20.8297C66.2539 20.3247 66.8074 19.5974 67.0985 18.7547C67.3896 17.912 67.403 16.9982 67.1367 16.1473C66.8704 15.2964 66.3384 14.5533 65.6187 14.0269C64.8991 13.5006 64.0297 13.2187 63.1382 13.2227Z"
      fill={colors.purple100}
    />
  </SvgIcon>
);
